import type { RequestMiddleware } from './gqlEngineUtils';
import { getObjectSelection } from './gqlObjectSelection';

export const gqlXLanguageMiddleware = (language: string): RequestMiddleware => {
	return (next) => (request) => {
		const objectSelection = getObjectSelection(request.info, request.context.variables);
		if (!objectSelection) return next(request);

		const {
			groupedVariables: { header, ...otherGroupedVariables },
			...otherRequest
		} = request;
		return next({
			...otherRequest,
			groupedVariables: {
				header: {
					...header,
					'X-Language': language,
				},
				...otherGroupedVariables,
			},
		});
	};
};
